<div class="text-sm flex" *ngIf="brandFacetValues.length">
    <span class='text-gray-500 mr-1'>Brand:</span>
    <a class="text-sm text-link mr-2" *ngFor="let brand of brandFacetValues" [routerLink]="['/c', brand.code]">
        {{ brand.name }}
    </a>
</div>
